import request from "@/utils/request";

export function apiGoogleOverview(params) {
  return request.get("/googleData/overview", params);
}

export function apiGoogleSiteData(params) {
  return request.get("/googleData/siteData", params);
}

export function apiGoogleAccounts(params) {
  return request.get("/googleData/accounts", params);
}

export function apiGoogleSiteBindings(params) {
  return request.get("/googleData/siteBindings", params);
}

export function apiGoogleSyncLogs(params) {
  return request.get("/googleData/logs", params);
}

export function apiGoogleCountryStats(params) {
  return request.get("/googleData/countryStats", params);
}

export function apiGoogleTrend(params) {
  return request.get("/googleData/trend", params);
}

export function apiGoogleDailyTrend(params) {
  return request.get("/googleData/dailyTrend", params);
}

export function apiGoogleTopPages(params) {
  return request.get("/googleData/topPages", params);
}

export function apiGoogleTopQueries(params) {
  return request.get("/googleData/topQueries", params);
}

export function apiGoogleSettings() {
  return request.get("/googleData/settings");
}

export function apiGoogleSyncStatus() {
  return request.get("/googleData/syncStatus");
}

export function apiGoogleSaveSettings(params) {
  return request.post("/googleData/saveSettings", params);
}

export function apiGoogleTestSettings() {
  return request.post("/googleData/testSettings");
}

export function apiGoogleSaveAccount(params) {
  return request.post("/googleData/saveAccount", params);
}

export function apiGoogleCheckAccount(params) {
  return request.post("/googleData/checkAccount", params, {
    timeout: 120 * 1000,
  });
}

export function apiGoogleSaveBinding(params) {
  return request.post("/googleData/saveBinding", params);
}

export function apiGoogleOAuthUrl(params) {
  return request.post("/googleData/oauthUrl", params);
}

export function apiGoogleSyncSite(params) {
  return request.post("/googleData/syncSite", params, { timeout: 120 * 1000 });
}

export function apiGoogleCheckBinding(params) {
  return request.post("/googleData/checkBinding", params, {
    timeout: 120 * 1000,
  });
}
